package pl.michal_cyran.brand_hub.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import pl.michal_cyran.brand_hub.components.layouts.PageLayoutData
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathTestsFeature
import pl.michal_cyran.brand_hub.pages.utils.PageContent
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathFinalCTA
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathProgressTracking
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathFunctionParameters
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathGenerators
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathMoreExercises
import pl.michal_cyran.brand_hub.subpages.dayMathAd.sections.DayMathHero

@InitRoute
fun initDayMathPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("DayMath"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun DayMathPage() {
    Column(
        modifier = Modifier
            .fillMaxSize()
    ) {
        PageContent(
            { DayMathHero() },
            { DayMathTestsFeature() },
            { DayMathGenerators() },
            { DayMathFunctionParameters() },
            { DayMathMoreExercises() },
            { DayMathProgressTracking() },
            { DayMathFinalCTA() },
        )
    }
}